export default "__VITE_ASSET__C8$DJQ8l__"